import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CustomerDeleteRes;
export const CustomerDeleteTodo = createAsyncThunk('CustomerDelete', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `customer_details/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CustomerDeleteRes = res.data

    } catch (error) {
        return CustomerDeleteRes = error.response.data
    }
})
